import { View, Text } from '@react-pdf/renderer';
import { Span } from '..';
import { en } from '../../theme/languages/en';
import { styles } from './EntityBankData.module';

interface EntityBankDataProps {
  title: string;
  data?: { key: string; value: string | number; isUpperCase?: boolean }[];
}

export const EntityBankData = ({ title, data }: EntityBankDataProps) => {
  return (
    <View style={styles.bottomContainer} wrap={false}>
      <Span style={[styles.text, styles.title]}>{title}</Span>

      {data.map((detail, index) => {
        return (
          !!detail.value && (
            <View style={styles.supplierData} key={index}>
              <View style={{ width: '140px' }}>
                <Span style={[styles.text, { lineHeight: '1px' }]}>{en[detail.key]}:</Span>
              </View>
              <Text style={[styles.text, { lineHeight: '1px' }]} wrap={false}>
                {detail?.value}
              </Text>
            </View>
          )
        );
      })}
    </View>
  );
};
